import { Controller } from "stimulus";

// Masks a stored credential (shows only the first characters + "…") and swaps
// the read-only display for an empty input when the user clicks to change it.
// The input is always submitted empty while untouched; the controller drops
// blank secret values on update, so the stored value is preserved untouched.
export default class extends Controller {
  static targets = ["mask", "input"];

  reveal() {
    // Inline !important beats the mask's `.d-flex { display: flex !important }`.
    this.maskTarget.style.setProperty("display", "none", "important");
    this.inputTarget.classList.remove("d-none");
    this.inputTarget.focus();
  }
}
